document.addEventListener('DOMContentLoaded', function () {

  // ── 左侧图片（替换为你自己的图片URL）──
  var stepImages = [
    'https://images.unsplash.com/photo-1518611012118-696072aa579a?w=600&q=80', // 问题1 占位图
    'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=600&q=80', // 问题2 占位图
    'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=600&q=80', // 问题3 占位图
    'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=600&q=80', // 问题4 占位图
    'https://images.unsplash.com/photo-1488716820095-cbe80883c496?w=600&q=80'  // 问题5 占位图
  ];

  // ── 产品数据 ──
  var products = {
    'CuteFoxM6': { name: 'CuteFoxM6',      img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/Love-egg-CuteFoxM6-01.png?v=1780555082', url: '/products/love-egg-cutefoxm6' },
    'F510':      { name: 'F510',            img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/Love-egg-F510-01.png?v=1780555673',    url: '/products/love-egg-f510' },
    'F520':      { name: 'F520',            img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/Love-egg-F520-01.png?v=1780555941',    url: '/products/love-egg-f520' },
    'F530':      { name: 'F530',            img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/Love-egg-F530-01.png?v=1780556056',    url: '/products/love-egg-f530' },
    'J520':      { name: 'J520',            img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/Love-egg-J520-01.jpg?v=1780556300',    url: '/products/love-egg-j520' },
    'V2':        { name: 'V2',              img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/Vibrator-V2-01.png?v=1780554980',      url: '/products/vibrator-v2' },
    'V30':       { name: 'V30',             img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/Vibrator-V30-01.png?v=1780553917',     url: '/products/vibrator-v30' },
    'R420':      { name: 'R420',            img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/Vibrator-R420-01.png?v=1780552144',    url: '/products/vibrator-r420' },
    'R540':      { name: 'R540',            img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/Vibrator-R540-01.png?v=1780552892',    url: '/products/vibrator-r540' },
    'R550':      { name: 'R550',            img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/Vibrator-R550-02.png?v=1780559082',    url: '/products/vibrator-r550' },
    'D10':       { name: 'D10',             img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/Dildos-D10-2.png?v=1780557673',        url: '/products/dildos-d10' },
    'D20':       { name: 'D20',             img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/Dildos-D20-2.jpg?v=1780557807',        url: '/products/dildos-d20' },
    'D50':       { name: 'D50',             img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/Dildos-D50.png?v=1780557746',          url: '/products/dildos-d50' },
    'M30':       { name: 'Phantom M30',     img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/M30.jpg?v=1780638946',                 url: '/products/m30' },
    'M50':       { name: 'Phantom M50',     img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/M50.jpg?v=1780639966',                 url: '/products/phantom-m50' },
    'M60':       { name: 'Phantom M60',     img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/M60-01.jpg?v=1780639154',              url: '/products/phantom-m60' },
    'M70':       { name: 'Phantom M70',     img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/M70.jpg?v=1780640146',                 url: '/products/phantom-m70' },
    'M70PRO':    { name: 'Phantom M70 PRO', img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/M70PRO-01.jpg?v=1780640043',           url: '/products/phantom-m70-pro' },
    'M510':      { name: 'M510',            img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/M510-01.jpg?v=1780639376',             url: '/products/m510' },
    'P310':      { name: 'P310',            img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/P310.jpg?v=1780639549',                url: '/products/p310' },
    'Qipao':     { name: 'Qipao Stroker',   img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/bf693862987c02186bdaac2b54b633ca.jpg?v=1780639822', url: '/products/qipao-stroker' },
    'S2':        { name: 'Dual Delight S2', img: 'https://cdn.shopify.com/s/files/1/0992/4532/6641/files/S2.jpg?v=1780639861',                  url: '/products/dual-delight-s2' }
  };

  // ── 推荐逻辑 ──
  function getRecommendations(a) {
    var g = a.q1, exp = a.q2, stim = a.q3, scene = a.q4, budget = a.q5;
    if (g === 'female') {
      if (exp === 'beginner') {
        if (stim === 'external') return ['CuteFoxM6', 'F510'];
        if (stim === 'internal') return ['V2', 'R420'];
        return ['V2', 'CuteFoxM6', 'F510'];
      }
      if (exp === 'intermediate') {
        if (scene === 'couple' || scene === 'portable') return ['J520', 'F520'];
        if (stim === 'internal') return ['R540', 'D10'];
        return ['R540', 'F520'];
      }
      if (budget === 'premium') return ['R550', 'V30', 'D50'];
      if (budget === 'mid') return ['R550', 'F530'];
      return ['F530', 'V30'];
    } else {
      if (exp === 'beginner') return budget === 'budget' ? ['M30', 'Qipao'] : ['M30', 'M50'];
      if (exp === 'intermediate') {
        if (stim === 'internal') return ['P310', 'M60'];
        if (scene === 'couple') return ['S2', 'M510'];
        return ['M50', 'M510'];
      }
      if (budget === 'premium') return ['M70PRO', 'M70', 'P310'];
      if (budget === 'mid') return ['M70', 'M60', 'S2'];
      return ['M60', 'M510'];
    }
  }

  var currentStep = 1, totalSteps = 5, answers = {};
  var overlay      = document.getElementById('foxQuizOverlay');
  var closeBtn     = document.getElementById('foxQuizClose');
  var trigger      = document.getElementById('foxQuizTrigger');
  var quizImage    = document.getElementById('foxQuizImage');
  var progressFill = document.getElementById('foxQuizProgressFill');
  var progressText = document.getElementById('foxQuizProgressText');
  var resultsEl    = document.getElementById('foxQuizResults');
  var productsEl   = document.getElementById('foxQuizProducts');
  var restartBtn   = document.getElementById('foxQuizRestart');

  function showStep(step) {
    document.querySelectorAll('.fox-quiz-step').forEach(function(el) { el.classList.remove('active'); });
    var el = document.querySelector('[data-step="' + step + '"]');
    if (el) el.classList.add('active');
    resultsEl.classList.remove('active');
    quizImage.src = stepImages[step - 1];
    var pct = Math.round(((step - 1) / totalSteps) * 100);
    progressFill.style.width = pct + '%';
    progressText.textContent = pct + '% complete';
  }

  function showResults() {
    document.querySelectorAll('.fox-quiz-step').forEach(function(el) { el.classList.remove('active'); });
    resultsEl.classList.add('active');
    progressFill.style.width = '100%';
    progressText.textContent = '100% complete';
    quizImage.src = stepImages[4];
    var recs = getRecommendations(answers);
    productsEl.innerHTML = '';
    recs.forEach(function(key) {
      var p = products[key];
      if (!p) return;
      var card = document.createElement('a');
      card.className = 'fox-quiz-product-card';
      card.href = p.url;
      card.innerHTML = '<img src="' + p.img + '" alt="' + p.name + '"><div><div class="fox-quiz-product-name">' + p.name + '</div><div class="fox-quiz-product-cta">查看详情 →</div></div>';
      productsEl.appendChild(card);
    });
  }

  function reset() {
    currentStep = 1; answers = {};
    document.querySelectorAll('input[type="radio"]').forEach(function(r) { r.checked = false; });
    showStep(1);
  }

  document.querySelectorAll('.fox-quiz-option input[type="radio"]').forEach(function(radio) {
    radio.addEventListener('change', function() {
      answers[this.name] = this.value;
      setTimeout(function() {
        if (currentStep < totalSteps) { currentStep++; showStep(currentStep); }
        else { showResults(); }
      }, 300);
    });
  });

if (trigger && overlay) {
  trigger.addEventListener('click', function(e) {
    e.preventDefault();
    overlay.classList.add('active');
    reset();
  });
}

if (closeBtn) {
  closeBtn.addEventListener('click', function() {
    overlay.classList.remove('active');
  });
}

if (overlay) {
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) overlay.classList.remove('active');
  });
}

if (restartBtn) {
  restartBtn.addEventListener('click', reset);
}
});

